import * as React from 'react';
import { Box } from "../box/Box";
import { Columns } from "../columns/Columns";
import Icon from "../icon/Icon";
import { useTheme } from "../../theme/ThemeProvider";
import Text from "../text/Text";
import { getAlertStyles } from "./Alert.styles";
export var Alert = function Alert(_ref) {
  var icon = _ref.icon,
      _ref$palette = _ref.palette,
      palette = _ref$palette === void 0 ? 'primary' : _ref$palette,
      text = _ref.text;
  var theme = useTheme();

  var _getAlertStyles = getAlertStyles({
    theme: theme,
    palette: palette
  }),
      backgroundColor = _getAlertStyles.backgroundColor,
      boxShadow = _getAlertStyles.boxShadow,
      iconColor = _getAlertStyles.iconColor,
      textColor = _getAlertStyles.textColor;

  return /*#__PURE__*/React.createElement(Box, {
    px: 3,
    py: 2,
    borderRadius: "4px",
    backgroundColor: backgroundColor,
    boxShadow: boxShadow
  }, /*#__PURE__*/React.createElement(Columns, {
    alignY: "center",
    space: "xSmall"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "medium",
    icon: icon,
    color: iconColor
  }), /*#__PURE__*/React.createElement(Text, {
    size: "regular",
    color: textColor
  }, text)));
};
export default Alert;